<template>
  <v-app id="inspire">

    <v-app-bar
      app
      color="primary"
      dark
    >
    </v-app-bar>

    <v-main>
      <!-- <v-card id="pantallas" class="elevation-3 " height="100%"> -->
        <v-container fluid class="mx-0">
          <v-slide-y-transition mode="out-in">
            <router-view />
          </v-slide-y-transition>
        </v-container>
      <!-- </v-card> -->
    </v-main>

  </v-app>

</template>

<script>
  export default {
    data: () => ({
    }),
  };
</script>

